import notifier from './notifier'
import sendData from "./sendData";
import inWindow from "./inWindow";

const commentForm = document.querySelector('.comment-form');
const commentTextarea = document.querySelector('.comment-form > .form-group > #id_text');
const commentParentField = document.querySelector('.comment-form > #id_parent');
const submitButton = document.querySelector('.btn-send-comment');
let starVotesForm = document.getElementById('comment-votes-stars');

const allTextareas = document.querySelectorAll('.comment-form > .form-group > textarea');
const aditiaonalFields = document.querySelectorAll('.comment-form > .form-group > .additional-field');



function returnFormToBeginState(){
    /* возвращаем форму к первоначальному состоянию
    * очищаем и уменьшаем текстареа
    * очищаем парент поле
    * снимаем дизаблед в кнопки отправки
    * показываем форму оценивания по параметрам, если она существует
    * возвращаем на место
    *  */
    const commentFormPlaceholder = document.getElementById('comment-form-placeholder');

    if (commentTextarea){
        allTextareas.forEach((textarea) => {
            textarea.value = '';
            textarea.style.height = '40px';
        });
        // если есть доп поля - показываем их
        aditiaonalFields.forEach((field) => {
          field.parentNode.classList.remove('d-none');
        });
    } else {
        // for forum
        $R('textarea.redactor_content', 'source.setCode', '');
    }

    commentParentField.value = '';

    submitButton.removeAttribute('disabled');
    submitButton.innerHTML = gettext('Отправить');

    if (starVotesForm){
        starVotesForm.classList.remove('d-none');
    }

    commentForm.parentElement.removeChild(commentForm);
    commentFormPlaceholder.appendChild(commentForm);
}

function addEventListenerToReplayButton(button) {
    const parent = button.parentNode;
    button.addEventListener('click', (event) => {
        event.preventDefault();
        if (commentForm) {
            commentForm.parentElement.removeChild(commentForm);
            parent.appendChild(commentForm);
            commentParentField.value = button.getAttribute('data-parent');
            if (commentTextarea){
                commentTextarea.value = '';
                commentTextarea.style.height = '200px';
                commentTextarea.focus();
                // если есть доп поля - скрываем их
                aditiaonalFields.forEach((field) => {
                  field.parentNode.classList.add('d-none');
                });
                // если есть форма оценивания - скрываем ее
                if (starVotesForm){
                    starVotesForm.classList.add('d-none');
                }
            } else {
                // for forum
                $R('textarea.redactor_content').editor.startFocus();
            }
        } else {
            notifier.alert(gettext('Оставлять сообщения могут только зарегистрированные пользователи.'));
        }
    });
}

function createComment() {
    const cancelButton = document.querySelector('.btn-cancel-comment');
    if (cancelButton){
        cancelButton.addEventListener('click', (event) => {
            event.preventDefault();
            returnFormToBeginState();
        });
    }

    allTextareas.forEach((textarea) => {
        textarea.addEventListener('click', (event) => {
            textarea.style.height = '200px';
        });
    });

    const commentList = document.querySelector('.comment-list');
    if (commentForm){
        commentForm.addEventListener('submit', (event) => {
            event.preventDefault();

            if (starVotesForm){
                if (!starVotesForm.classList.contains('d-none')) {
                    // если звезды показываются
                    if (starVotesForm.querySelectorAll('input:checked').length == 0) {
                        const description = starVotesForm.querySelector('.rating-description');
                        notifier.alert(description.innerHTML);
                        description.scrollIntoView();
                        return false;
                    }
                }
            }

            if (!commentTextarea){
                // validator for forum
                if ($R('textarea.redactor_content').editor.isEmpty() == true){
                    notifier.alert(gettext('Вы не ввели текст сообщения.'));
                    return false;
                }
            }
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.innerHTML = gettext('Отправляется...');

            sendData('POST', commentForm.getAttribute('action'), new FormData(commentForm))
            .then((data) => {
                if (data.success) {
                    let target = commentList;
                    // сообщение об успехе
                    notifier.success(data.message);
                    // возвращаем форму в исходное состояние
                    returnFormToBeginState();
                    // выводим новый коммент
                    let position = data.position;
                    if (data.parent){
                        target = document.getElementById('comment-item-content-' + data.parent);
                        position = 'afterEnd';
                    } else {
                        // удаляем форму со звездами - при наличии
                        if (starVotesForm){
                            starVotesForm.parentNode.removeChild(starVotesForm);
                            starVotesForm = null;
                        }
                        // удаляем доп поля - при наличии
                        aditiaonalFields.forEach((field) => {
                            let formGroup = field.parentNode;
                            formGroup.parentNode.removeChild(formGroup);
                        });
                    }
                    target.insertAdjacentHTML(
                        position,
                        data.html
                    );
                    // добавляем слушатель событий для ответа на новый коммент
                    addEventListenerToReplayButton(document.getElementById('comment-reply-' + data.id));
                    // добавляем слушатель событий для оценки на нового коммента
                    document.querySelectorAll('.vote-form-' + data.id +' > .vote-form__button').forEach(
                        (vote_btn) => {
                            vote_btn.addEventListener('click', (event) => {
                                event.preventDefault();
                                notifier.alert(gettext('Вы не можете голосовать за этот комментарий, так как являетесь его автором.'));
                                return false;

                        })
                    });
                } else {
                    notifier.alert(data.message);
                    submitButton.removeAttribute('disabled');
                    submitButton.innerHTML = gettext('Отправить');
                }
            });
            return false;
        });
    }

    document.querySelectorAll('.comment-reply').forEach(function (button) {
        addEventListenerToReplayButton(button);
    });
};

let xhr;
function MakeCommentsOld(comments, command){
  if (comments.length){
    comments.forEach((comment) => {
      let id = comment.getAttribute('data-id');
      xhr = sendData('POST', Urls['cabinet_comments_read_item'](id),{'type': command, 'pk': id})
            .then((data) => {
                if (data.success){
                    comment.classList.remove('new-'+command);
                } else {
                    console.debug(data);
                }
            });
    });
  }
}

function readComments(){
    let answers = inWindow(".new-answer");
    MakeCommentsOld(answers, 'answer');

    let comments = inWindow(".new-comment");
    MakeCommentsOld(comments, 'comment');

    window.addEventListener('scroll', function() {
        let answers = inWindow(".new-answer");
        MakeCommentsOld(answers, 'answer');

        let comments = inWindow(".new-comment");
        MakeCommentsOld(comments, 'comment');
    });
}

export {createComment, readComments};
